<template>
  <div class="headerContainer">
    <div class="welcome">
      <p v-if="data != ''">{{ data.user_name + "，" + timeText }}</p>
    </div>
    <div class="info" @click="onDocument">
      <a-icon type="question-circle" />
      <p>在线文档</p>
    </div>
    <div class="info" @click="message">
      <a-icon type="message" />
      <p>我的消息</p>
    </div>
    <div class="info" @click="exit">
      <a-icon type="logout" />
      <p>退出</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      data: "",
      timeText: ""
    };
  },
  mounted() {
    this.getInfo();
    this.getText();
  },
  methods: {
    getText() {
      let hour = Number(moment().format("HH"));
      if ([5, 6, 7, 8].indexOf(hour) != -1) {
        this.timeText = "早上好，一起努力吧";
      }
      if ([9, 10, 11].indexOf(hour) != -1) {
        this.timeText = "上午好，一起努力吧";
      }
      if ([12, 13].indexOf(hour) != -1) {
        this.timeText = "中午好，记得享受窗外的阳光";
      }
      if ([14, 15, 16, 17, 18].indexOf(hour) != -1) {
        this.timeText = "下午好，欢迎回来";
      }
      if ([19, 20, 21, 22].indexOf(hour) != -1) {
        this.timeText = "晚上好，欢迎回来";
      }
      if ([23, 24, 0, 1, 2, 3, 4].indexOf(hour) != -1) {
        this.timeText = "已经凌晨了，请注意休息";
      }
    },
    exit() {
      this.$router.push({ name: "login" });
    },
    message() {
      this.$router.push({ name: "message" });
    },
    getInfo() {
      let _this = this;
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "User/querySelfUserInfo";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data;
          } else if (res.data.code == -10 || res.data.code == -11) {
            this.$info({
              title: "重新登录",
              content: "您的登录已过期或失效，请重新登录！",
              onOk() {
                _this.$router.push({ name: "login" });
              }
            });
          } else if (res.data.code == 500) {
            _this.$router.push({ name: "500" });
          }
        })
        .catch(err => {
          _this.$router.push({ name: "404" });
        });
    },
    onDocument() {
      // window.location.href = "http://public.xnserve.com/erpOerationDoc.docx";
      let routeUrl = this.$router.resolve({
        path: "/setting/document"
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.headerContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  .info {
    margin-left: 12px;
    cursor: pointer;
    i {
      margin-right: 4px;
    }
  }
  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .welcome {
    margin-right: 20px;
  }
}
</style>
